import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import SearchFacetsViewModel from 'viewmodel/SearchFacetsViewModel';

export default class DesSearchFacets extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        this.createReactElement();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        ReactDOM.unmountComponentAtNode(this);
        this.createReactElement();
    }

    createReactElement() {
        ReactDOM.render(
            <AppCtxComponent>
                {React.createElement(
                    SearchFacetsViewModel,
                    {
                        ...this.getProps()
                    },
                    React.createElement('slot')
                )}
            </AppCtxComponent>,
            this);
    }

    getProps() {
        return {
            viewId: 'searchFacetsView',
            viewPath: 'viewPath'
        };
    }

    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }
}
if (!window.customElements.get('des-search-facets')) {
    window.customElements.define(
        'des-search-facets',
        DesSearchFacets
    );
}
